import { FaIdCard, FaPercentage, FaUser, FaBriefcase, FaBuilding, FaChartBar, FaChartArea } from 'react-icons/fa';

/**
 * Configuración de columnas para la tabla de usuarios
 * Estructura: { id, label, sortable, align, icon, width, formatter }
 */
export const usuariosColumnConfig = [
    {
        id: 'identificacion',
        label: 'Identificación',
        sortable: true,
        align: 'left',
        icon: FaIdCard,
        width: 'auto',
        formatter: (value) => value,
    },
    {
        id: 'nombre',
        label: 'Nombre',
        sortable: true,
        align: 'left',
        icon: FaUser,
        width: 'auto',
        formatter: (value) => value,
    },
      {
        id: 'empresa',
        label: 'Empresa',
        sortable: true,
        align: 'left',
        icon: FaBuilding,
        width: 'auto',
        formatter: (value) => value,
    },
    {
        id: 'area',
        label: 'Area',
        sortable: true,
        align: 'left',
        icon: FaChartArea,
        width: 'auto',
        formatter: (value) => value,
    },
    {
        id: 'cargo',
        label: 'Cargo',
        sortable: true,
        align: 'left',
        icon: FaBriefcase,
        width: 'auto',
        formatter: (value) => value,
    },
    {
        id: 'participacion',
        label: 'Participación',
        sortable: true,
        align: 'center',
        icon: FaPercentage,
        width: 'auto',
        formatter: (value) => `${value}%`,
    },
];

/**
 * Obtiene la configuración de columnas
 * @param {string} type - Tipo de tabla ('usuarios' por defecto)
 * @returns {Array} Array de configuración de columnas
 */
export const getColumnConfig = (type = 'usuarios') => {
    switch (type) {
        case 'usuarios':
            return usuariosColumnConfig;
        default:
            return usuariosColumnConfig;
    }
};

export default {
    usuariosColumnConfig,
    getColumnConfig,
};
